import profile from "app/modules/_profile";
import { FeatureFlag } from "utils/feature-flag";
import AccessoryShopMiniCart from "app/modules/_accessory-shop-mini-cart";

document.addEventListener('DOMContentLoaded', () => {
  profile()

  if (! FeatureFlag.hideStandaloneAccessoryShop()) {
    (new AccessoryShopMiniCart).ready()
  }
})
